function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, e, o, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), e, o); return 2 & r && "function" == typeof p ? function (t) { return p.apply(o, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var _ = require('underscore'),
  events = require('../events'),
  qualityOptionFactory = require('./QualityOption'),
  QUALITY_CHANGE_CLASS = 'vjs-quality-changing';
module.exports = function (videojs) {
  var MenuButton = videojs.getComponent('MenuButton'),
    QualityOption = qualityOptionFactory(videojs);

  /**
   * A component for changing video resolutions
   *
   * @class QualitySelector
   * @extends videojs.Button
   */
  var QualitySelector = /*#__PURE__*/function (_MenuButton) {
    /**
     * @inheritdoc
     */
    function QualitySelector(player, options) {
      var _this;
      _classCallCheck(this, QualitySelector);
      _this = _callSuper(this, QualitySelector, [player, options]);

      // Update interface instantly so the user's change is acknowledged
      player.on(events.QUALITY_REQUESTED, function (event, newSource) {
        this.setSelectedSource(newSource);
        player.addClass(QUALITY_CHANGE_CLASS);
        player.one('loadeddata', function () {
          player.removeClass(QUALITY_CHANGE_CLASS);
        });
      }.bind(_this));

      // Update the list of menu items only when the list of sources change
      player.on(events.PLAYER_SOURCES_CHANGED, function () {
        this.update();
      }.bind(_this));
      player.on(events.QUALITY_SELECTED, function (event, newSource) {
        // Update the selected source with the source that was actually selected
        this.setSelectedSource(newSource);
      }.bind(_this));

      // Since it's possible for the player to get a source before the selector is
      // created, make sure to update once we get a "ready" signal.
      player.one('ready', function () {
        this.selectedSrc = player.src();
        this.update();
      }.bind(_this));
      _this.controlText('Open quality selector menu');
      return _this;
    }

    /**
     * Updates the source that is selected in the menu
     *
     * @param source {object} player source to display as selected
     */
    _inherits(QualitySelector, _MenuButton);
    return _createClass(QualitySelector, [{
      key: "setSelectedSource",
      value: function setSelectedSource(source) {
        var src = source ? source.src : undefined;
        if (this.selectedSrc !== src) {
          this.selectedSrc = src;
          _.each(this.items, function (item) {
            item.selected(item.source.src === src);
          });
        }
      }

      /**
       * @inheritdoc
       */
    }, {
      key: "createItems",
      value: function createItems() {
        var player = this.player(),
          sources = player.currentSources();
        if (!sources || sources.length < 2) {
          return [];
        }
        return _.map(sources, function (source) {
          return new QualityOption(player, {
            source: source,
            selected: source.src === this.selectedSrc
          });
        }.bind(this));
      }

      /**
       * @inheritdoc
       */
    }, {
      key: "buildWrapperCSSClass",
      value: function buildWrapperCSSClass() {
        return 'vjs-quality-selector ' + _superPropGet(QualitySelector, "buildWrapperCSSClass", this, 3)([]);
      }
    }]);
  }(MenuButton);
  videojs.registerComponent('QualitySelector', QualitySelector);
  return QualitySelector;
};